<script lang="ts">
  import { isValidDate, isValidTelNo } from '../../../../components/validator/Validator';
  import { format, isAfter, addDays, isWednesday, isThursday } from 'date-fns';
  import { ja } from 'date-fns/locale';
  import { form, field } from 'svelte-forms';
  import { required } from 'svelte-forms/validators';

  export let handleConfirmEvent!: any;
  export let item: any;

  const constructionHopeDate1 = field('constructionHopeDate1', item?.constructionHopeDate1 ?? '', [
    required(),
    isValidDate
  ]);
  const constructionHopeDate2 = field('constructionHopeDate2', item?.constructionHopeDate2 ?? '', [
    required(),
    isValidDate
  ]);
  const constructionHopeDate3 = field('constructionHopeDate3', item?.constructionHopeDate3 ?? '', [
    required(),
    isValidDate
  ]);
  const respondentName = field('respondentName', item?.respondentName ?? '', [required()]);
  const respondentTelNo = field('respondentTelNo', item?.respondentTelNo ?? '', [required(), isValidTelNo]);
  const myForm = form(
    constructionHopeDate1,
    constructionHopeDate2,
    constructionHopeDate3,
    respondentName,
    respondentTelNo
  );

  const handleConfirm = async () => {
    let isFormValid = false;
    await myForm.validate().then(() => {
      isFormValid = $myForm.valid;
    });
    if (!isFormValid) {
      return;
    }

    let errorMessage = '';
    // 工事希望日1 単項目チェック
    if (!isAfterDay($constructionHopeDate1.value, 6)) {
      errorMessage += '工事希望日1は現在日+7日以降の日付入力してください。\n';
    } else if (isBusinessErrorDayOfWeek($constructionHopeDate1.value)) {
      errorMessage += '工事希望日1は水・木曜日以外の曜日を入力してください。\n';
    }

    // 工事希望日2 単項目チェック
    if (!isAfterDay($constructionHopeDate2.value, 6)) {
      errorMessage += '工事希望日2は現在日+7日以降の日付入力してください。\n';
    } else if (isBusinessErrorDayOfWeek($constructionHopeDate2.value)) {
      errorMessage += '工事希望日2は水・木曜日以外の曜日を入力してください。\n';
    }

    // 工事希望日3 単項目チェック
    if (!isAfterDay($constructionHopeDate3.value, 6)) {
      errorMessage += '工事希望日3は現在日+7日以降の日付入力してください。\n';
    } else if (isBusinessErrorDayOfWeek($constructionHopeDate3.value)) {
      errorMessage += '工事希望日3は水・木曜日以外の曜日を入力してください。\n';
    }

    if (errorMessage) {
      alert(errorMessage);
      return;
    }

    // 入力内容の呼び出し元画面への反映
    handleConfirmEvent({
      constructionHopeDate1: $constructionHopeDate1.value,
      constructionHopeDate2: $constructionHopeDate2.value,
      constructionHopeDate3: $constructionHopeDate3.value,
      respondentName: $respondentName.value,
      respondentTelNo: $respondentTelNo.value
    });
  };

  const isAfterDay = (value: string, addDay: number = 0): boolean => {
    return isAfter(new Date(value), addDays(new Date(), addDay));
  };

  const isBusinessErrorDayOfWeek = (value: string): boolean => {
    const date = new Date(value);
    if (isWednesday(date) || isThursday(date)) {
      return true;
    }
  };
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">設備撤去工事について</h1>
    </div>
  </div>
  <div class="shadow rounded bg-white border-t-2 border-green-400">
    <div class="flex-1 m-10">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>お客様の契約タイプは解約により回線設備の撤去工事が必要となります</p>
          <p>以下内容をご確認の上、必要事項を記入の上、確認ボタンを押下ください。</p>
        </div>
      </div>
    </div>

    <div class="flex-1 m-10">
      <form>
        <div class="flex flex-col justify-items-center items-center">
          <div class="shadow rounded bg-gray-50 w-11/12 content-center p-4">
            <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
              <div class="grid-1 justify-self-start w-full">
                <span class="form-label-title required">撤去工事希望日1</span>
              </div>
              <div class="grid-1 justify-self-start w-full">
                <input
                  type="date"
                  autocomplete="off"
                  bind:value={$constructionHopeDate1.value}
                  min={format(new Date(), 'yyyy-MM-dd', { locale: ja })}
                />
                {#if $myForm.hasError('constructionHopeDate1.required')}
                  <p class="text-red-500 text-xs mt-2">撤去工事希望日1を入力してください</p>
                {/if}
                {#if $myForm.hasError('constructionHopeDate1.invalid_date')}
                  <p class="text-red-500 text-xs mt-2">撤去工事希望日1に正しい日付を入力してください</p>
                {/if}
              </div>
            </div>

            <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
              <div class="grid-1 justify-self-start w-full">
                <span class="form-label-title required">撤去工事希望日2</span>
              </div>
              <div class="grid-1 justify-self-start w-full">
                <input
                  type="date"
                  autocomplete="off"
                  bind:value={$constructionHopeDate2.value}
                  min={format(new Date(), 'yyyy-MM-dd', { locale: ja })}
                />
                {#if $myForm.hasError('constructionHopeDate2.required')}
                  <p class="text-red-500 text-xs mt-2">撤去工事希望日2を入力してください</p>
                {/if}
                {#if $myForm.hasError('constructionHopeDate2.invalid_date')}
                  <p class="text-red-500 text-xs mt-2">撤去工事希望日2に正しい日付を入力してください</p>
                {/if}
              </div>
            </div>

            <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
              <div class="grid-1 justify-self-start w-full">
                <span class="form-label-title required">撤去工事希望日3</span>
              </div>
              <div class="grid-1 justify-self-start w-full">
                <input
                  type="date"
                  autocomplete="off"
                  bind:value={$constructionHopeDate3.value}
                  min={format(new Date(), 'yyyy-MM-dd', { locale: ja })}
                />
                {#if $myForm.hasError('constructionHopeDate3.required')}
                  <p class="text-red-500 text-xs mt-2">撤去工事希望日3を入力してください</p>
                {/if}
                {#if $myForm.hasError('constructionHopeDate3.invalid_date')}
                  <p class="text-red-500 text-xs mt-2">撤去工事希望日3に正しい日付を入力してください</p>
                {/if}
              </div>
            </div>

            <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
              <div class="grid-1 justify-self-start min-w-full">
                <span class="form-label-title required">ご対応者様 氏名</span>
              </div>
              <div class="grid-1 justify-self-start w-full">
                <input type="text" maxlength="100" bind:value={$respondentName.value} placeholder="" />
                {#if $myForm.hasError('respondentName.required')}
                  <p class="text-red-500 text-xs mt-2">ご対応者様 氏名を入力してください</p>
                {/if}
              </div>
            </div>
            <div class="inline-grid grid-cols-2 items-center min-w-full p-2">
              <div class="grid-1 justify-self-start min-w-full">
                <span class="form-label-title required">ご対応者様 連絡先電話番号</span>
              </div>
              <div class="grid-1 justify-self-start w-full">
                <input type="tel" maxlength="14" bind:value={$respondentTelNo.value} placeholder="0312345678" />
                {#if $myForm.hasError('respondentTelNo.required')}
                  <p class="text-red-500 text-xs mt-2">ご対応者様 連絡先電話番号を入力してください</p>
                {/if}
                {#if $myForm.hasError('respondentTelNo.invalid_tel_no')}
                  <p class="text-red-500 text-xs mt-2">正しい電話番号を入力してください</p>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="flex-1 m-10">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <ul class="list-none">
            <li>
              <p>※1週間以内に、弊社担当よりお客様へご連絡させていただきます</p>
            </li>
            <li>
              <p>※工事受付状況等により工事希望日に添えない場合がある点をご了承ください</p>
            </li>
            <li>
              <p>※撤去工事は30分から1時間程度となります</p>
            </li>
            <li>
              <p>※撤去工事にあたって工事費用は発生しません</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="flex flex-col justify-items-center items-center">
      <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
        <button class="button-primary md:ml-5 mb-5" on:click={handleConfirm}> 確認 </button>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  p {
    @apply tracking-normal mb-1;
  }
  .form-label-title {
    @apply text-sm font-medium text-gray-700;
  }
  .required:after {
    content: ' *';
    color: red;
  }
  input[type='text'],
  input[type='date'],
  input[type='tel'] {
    width: 60%;
    @apply rounded border py-2 px-3 text-sm placeholder-gray-400 focus:placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-transparent w-full;
  }
  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }
</style>
